import { WidgetActionMethod } from '../../WidgetVariant';

enum EmbeddedActionMethod {
  InitiateSimplrChat = 'initiateSimplrChat',
}

export type ActionMethod = EmbeddedActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...EmbeddedActionMethod,
  ...WidgetActionMethod,
};
